(() => {
  const init = (scope = document) => {
    const roots = scope.matches?.('[data-km-chrome]') ? [scope] : scope.querySelectorAll('[data-km-chrome]');
    roots.forEach((root) => {
      if (root.dataset.kmReady) return;
      root.dataset.kmReady = 'true';
      const toggle = root.querySelector('[data-km-menu-toggle]');
      const menu = root.querySelector('.km-mobile-nav');
      const dialog = root.querySelector('.km-search-dialog');
      const opener = root.querySelector('[data-km-search-open]');
      const setMenu = (open) => {
        if (!menu || !toggle) return;
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
      };
      toggle?.addEventListener('click', () => setMenu(menu.hidden));
      menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu && !menu.hidden) {
          setMenu(false);
          toggle.focus();
        }
      });
      opener?.addEventListener('click', () => {
        setMenu(false);
        if (!dialog.open) dialog.showModal();
        dialog.querySelector('input[type="search"]')?.focus();
      });
      root.querySelector('[data-km-search-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog?.addEventListener('close', () => opener?.focus());
      root.querySelectorAll('.km-nav-dropdown').forEach((details) => {
        details.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            details.open = false;
            details.querySelector('summary').focus();
          }
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
